import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Stack } from '@mui/material';
import PurchaseRegisterTable from './PurchaseRegisterTable';

const PurchaseRegister = () => {
  const [isChanged, setIsChanged] = useState(false);

  return (
    <>
      <Container>
        <Stack direction="column" justifyContent="flex-start" width="100%" my={2}>
          <PurchaseRegisterTable isChanged={isChanged} setIsChanged={setIsChanged} />
        </Stack>
      </Container>
    </>
  );
};

export default PurchaseRegister;
